import { DEFAULT_PARAMETER_OPTIONS } from 'pages/OrganizationManagement/constants';


export const getFilterParameterOptions = (customizedParameters) => (
  [...DEFAULT_PARAMETER_OPTIONS].map(p => {
    const existingParam = (customizedParameters ?? []).find(param => param.name === p.name);

    return {
      ...p,
      name: existingParam?.name ?? p.name,
      value: existingParam?.value ?? p.value,
    };
  }).filter(p => Boolean(p.value)));
